import "./_header.scss";

import {NavProps} from "./interface";

function Nav({links}: NavProps): JSX.Element {
  let linksList: JSX.Element[] | null = null;
  if (links.length > 0) {
    linksList = links.map((link): JSX.Element => {
      const {name, url} = link;
      return (
        <li key={url}>
          <a href={url}>{name}</a>
        </li>
      );
    });
  }
  return (
    <nav className="stroke">
      <ul>{linksList}</ul>
    </nav>
  );
}

export default Nav;
